import { useEffect } from "react";
import { Outlet, Link, useLocation } from "react-router";
import TitleUpdater from "@core/components/titleUpdater/TitleUpdater";
import Footer from "@core/layouts/footer/Footer";
import NavLinkTabs from "@features/service/components/NavLinkTabs";
import { Toaster } from "@core/components/ui/Sonner";
import LogoSvg from "@/assets/svg/header/logo.svg?react";
import { House } from "lucide-react";
import { cn } from "@core/utils";

export default function ServiceLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <TitleUpdater />
      <div className="flex h-[60px] justify-center border-b border-gray-200 lg:h-[80px]">
        <Link to="/" className="flex items-center gap-[10px]">
          <span className="block rounded-md bg-gray-100 p-[4px]">
            <House className="size-[18px] stroke-gray-700" />
          </span>
          <LogoSvg className={cn("h-[18px] w-[128px] lg:h-[25px] lg:w-[182px]")} />
        </Link>
      </div>
      <NavLinkTabs />
      <Outlet />
      <Footer />
      <Toaster />
    </>
  );
}
